<template>
  <setting-section
    class="open-door-settings"
    :title="$t('machineConfig.openDoorSetting')"
    :help="$t('configHelp.openDoorSetting')"
  >
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.detectType')">
          <div class="static-value">{{ detectTypeLabel }}</div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.cameraSelect')">
          <div class="static-value">{{ cameraSelectLabel }}</div>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.pendOrderAlarm')">
          <setting-switch
            :value="localValue.pendOrderAlarmSwitch"
            @input="handleChange('pendOrderAlarmSwitch', $event)"
          ></setting-switch>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.pendOrderAlarmSwitch === 1">
        <el-form-item :label="$t('machineConfig.pendOrderAlarmNum')">
          <el-input 
            :value="localValue.pendOrderAlarmNum" 
            @input="handleChange('pendOrderAlarmNum', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.times') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.pendOrderAlarmSwitch === 1">
        <el-form-item :label="$t('machineConfig.pendOrderAlarmDisableMachine')">
          <el-input 
            :value="localValue.pendOrderAlarmDisableMachine" 
            @input="handleChange('pendOrderAlarmDisableMachine', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">orders</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.orderTimeoutWarn')">
          <setting-switch
            :value="localValue.orderTimeoutWarnSwitch"
            @input="handleChange('orderTimeoutWarnSwitch', $event)"
          ></setting-switch>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.orderTimeoutWarnSwitch === 1">
        <el-form-item :label="$t('machineConfig.orderTimeoutWarnTime')">
          <el-input 
            :value="localValue.orderTimeoutWarnTime" 
            @input="handleChange('orderTimeoutWarnTime', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.minutes') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.longTimeSettleOrder')">
          <setting-switch
            :value="localValue.longTimeSettleOrderSwitch"
            @input="handleChange('longTimeSettleOrderSwitch', $event)"
          ></setting-switch>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.longTimeSettleOrderSwitch === 1">
        <el-form-item :label="$t('machineConfig.closeTime')">
          <el-input 
            :value="localValue.closeTimeSet" 
            @input="handleChange('closeTimeSet', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.hours') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.orderTimeoutCharge')">
          <setting-switch
            :value="localValue.orderTimeoutChargeSwitch"
            @input="handleChange('orderTimeoutChargeSwitch', $event)"
          ></setting-switch>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.orderTimeoutChargeSwitch === 1">
        <el-form-item :label="$t('machineConfig.orderTimeoutSet')">
          <el-input
            :value="localValue.orderTimeoutSet"
            @input="handleChange('orderTimeoutSet', $event)"
            placeholder="Enter number"
            type="number"
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.minutes') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item :label="$t('machineConfig.preAuthAmount')">
          <el-input
            v-model="preAuthDollars"
            placeholder="0"
            type="number"
            min="0"
            step="1"
            autocomplete="off"
          >
            <template slot="prepend">$</template>
            <el-button
              slot="append"
              :loading="preAuthSaving"
              @click="savePreAuthAmount"
            >
              {{ $t('common.definite') }}
            </el-button>
          </el-input>
          <div class="pre-auth-hint">{{ $t('machineConfig.preAuthAmountHint') }}</div>
        </el-form-item>
      </el-col>
    </el-row>
  </setting-section>
</template>

<script>
import SettingSection from '../SettingSection.vue';
import SettingSwitch from '../SettingSwitch.vue';

export default {
  name: 'OpenDoorSettings',
  components: { SettingSection, SettingSwitch },
  props: {
    value: { type: Object, default: () => ({}) },
    yesNo: { type: Array, default: () => [] },
    userEquipmentId: { type: String, default: '' }
  },
  data() {
    return {
      detectTypeList: [
        { value: 1, label: this.$t('machineConfig.visualWeightDetection') },
        { value: 2, label: this.$t('machineConfig.visualDetection') },
        { value: 3, label: this.$t('machineConfig.weightDetection') }
      ],
      cameraSelectList: [
        { value: 1, label: this.$t('machineConfig.dualCamera') },
        { value: 2, label: this.$t('machineConfig.quadCamera') }
      ],
      // Nayax 存储/接收的单位是美分（cents），这里只做展示层的整美元转换
      preAuthDollars: '',
      preAuthSaving: false
    };
  },
  computed: {
    localValue() {
      return this.value || {};
    },
    detectTypeLabel() {
      const match = this.detectTypeList.find(item => item.value === this.localValue.detectType);
      return match ? match.label : this.$t('machineConfig.visualDetection');
    },
    cameraSelectLabel() {
      const match = this.cameraSelectList.find(item => item.value === this.localValue.cameraSelect);
      return match ? match.label : this.$t('machineConfig.dualCamera');
    }
  },
  watch: {
    'value.preAuthAmount': {
      immediate: true,
      handler(cents) {
        const n = Number(cents);
        this.preAuthDollars = n > 0 ? String(Math.round(n / 100)) : '';
      }
    }
  },
  methods: {
    handleChange(key, val) {
      this.$emit('input', { ...this.localValue, [key]: val });
    },
    savePreAuthAmount() {
      if (!this.userEquipmentId) {
        this.$notify({
          title: this.$t('common.tip'),
          message: this.$t('machineConfig.preAuthAmountMissingEquipment'),
          type: 'error'
        });
        return;
      }
      const dollars = Number(this.preAuthDollars);
      if (!Number.isInteger(dollars) || dollars < 0) {
        this.$notify({
          title: this.$t('common.tip'),
          message: this.$t('machineConfig.preAuthAmountInvalid'),
          type: 'error'
        });
        return;
      }
      const cents = dollars * 100;
      this.preAuthSaving = true;
      this.$api
        .request(this.$url.UserMachine.updatePreAuthAmount, this.$method.post, {
          userEquipmentId: this.userEquipmentId,
          preAuthAmount: cents
        })
        .then(res => {
          if (res.code === 0) {
            this.handleChange('preAuthAmount', cents);
            this.$notify({
              title: this.$t('common.tip'),
              message: this.$t('editUserMachine.up'),
              type: 'success'
            });
          } else {
            this.$notify({
              title: this.$t('common.tip'),
              message: res.msg || this.$t('machineConfig.preAuthAmountInvalid'),
              type: 'error'
            });
          }
        })
        .catch(err => {
          this.$notify({
            title: this.$t('common.tip'),
            message: (err && err.msg) || this.$t('machineConfig.preAuthAmountInvalid'),
            type: 'error'
          });
        })
        .finally(() => {
          this.preAuthSaving = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.open-door-settings {
  .static-value {
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    border-radius: 4px;
    background: var(--vtm-bg-2, #f5f7fa);
    color: var(--vtm-ink, #303133);
    font-size: 14px;
  }

  .pre-auth-hint {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.4;
    color: #909399;
  }
}
</style>
